
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topclinicaltrials/privacy-policy",
      function () {
        return require("private-next-pages/topclinicaltrials/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topclinicaltrials/privacy-policy"])
      });
    }
  